import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=427fec58&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=427fec58&prod&lang=scss&scoped=true"
import style1 from "./ItemsList.vue?vue&type=style&index=1&id=427fec58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427fec58",
  null
  
)

export default component.exports